export default "/images/framework/WalletLink.a7c6a425.svg?a7c6a425";